export default __webpack_public_path__ + "static/media/watch_dark.7c30b066.png";